import { put, all, takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* fetchDashboardDataSaga({payload}) {
  try {
    yield put({ type: actionTypes.SET_LOADING, payload: true });
    const { timerange } = payload;

    const { data } = yield API.get(`/dashboard?timerange=${timerange}`);

    if (data.success) {
        const transformedData = {
            uploadByProjectData: data.data.uploadsByProject || [],
            sourceTypeData: data.data.sourceTypeDistribution || [],
            uploadsOverTimeData: data.data.uploadsOverTime || [],
            vendorVsChannelData: data.data.vendorVsChannelPartnerUploads || [],
            projectUploadVolume: data.data.masterProjectUploadVolume || [],
            userOnboardingData: data.data.userOnboardingOverTime || [],
          };
        yield put({ type: actionTypes.FETCH_DASHBOARD_DATA_SUCCESS, payload: transformedData });
    } else {
        toast.error(data?.message || "Could not fetch dashboard data.");
        yield put({ type: actionTypes.FETCH_DASHBOARD_DATA_FAILURE, payload: {message: data?.message || "Could not fetch dashboard data."} });
    }
    
  } catch (error) {
    handleApiError(error, "Could not fetch dashboard data.");
    const data = error?.response?.data;
    yield put({ type: actionTypes.FETCH_DASHBOARD_DATA_FAILURE, payload: data || { message: "Internal server error" } });

  }
}

function* DashboardSaga() {
  yield all([
   takeLatest(actionTypes.FETCH_DASHBOARD_DATA, fetchDashboardDataSaga)
  ]);
}

export default DashboardSaga;